import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import { z } from "zod"
import { FEED_SORTS, recordFeedPageVisit } from "@/entities/feed"
import { FeedListPage } from "@/pages/feed"

const searchDefaults = { tab: "cards", sort: "chrono" } as const

const searchSchema = z.object({
	tab: z
		.enum(["cards", "daily-question"])
		.default(searchDefaults.tab)
		.catch(searchDefaults.tab),
	sort: z
		.enum(FEED_SORTS)
		.default(searchDefaults.sort)
		.catch(searchDefaults.sort),
})

export const Route = createFileRoute("/_authenticated/feed/")({
	validateSearch: searchSchema,
	search: { middlewares: [stripSearchParams(searchDefaults)] },
	onEnter: recordFeedPageVisit,
	component: FeedListPageWrapper,
})

function FeedListPageWrapper() {
	const { tab, sort } = Route.useSearch()
	return <FeedListPage tab={tab} sort={sort} />
}
